import { CLEAR_WEIGTH_STATE, GET_WEIGHT_ERROR, GET_WEIGHT_REQUEST, GET_WEIGHT_SUCCESS } from './constants';

export const getWeightRequest = (url: string, fieldName: string) => ({
  type: GET_WEIGHT_REQUEST,
  payload: url,
  fieldName,
});

export const getWeightSuccess = (weight: string) => ({
  type: GET_WEIGHT_SUCCESS,
  payload: weight,
});

export const getWeightError = (error: Error | null) => ({
  type: GET_WEIGHT_ERROR,
  payload: error,
});

export const clearWeightState = () => ({
  type: CLEAR_WEIGTH_STATE,
});

export type Actions =
  | ReturnType<typeof getWeightRequest>
  | ReturnType<typeof getWeightSuccess>
  | ReturnType<typeof getWeightError>
  | ReturnType<typeof clearWeightState>;
